export default __webpack_public_path__ + "static/media/Boots of the Putrescent.04a6f0ad.jpg";